import { useEffect } from "react";
import Layouts from "../../Layouts";
import { getBomHistory, getBomDetails, getColumns, getDigiKeyBomEnrichment, getFile } from "../../../actions";
import { connect } from "react-redux";
import "./historyStyle.css";
import HistoryTable from "./HistoryTable";

const History = (props) => {
  useEffect(() => {
    if (!props.columns?.length && props.user.token) {
      props.getColumns(props.user.token);
    }
  }, [props.columns, props.getColumns, props.user.token]);

  return (
    <Layouts>
      <HistoryTable
        user={props.user}
        columns={props.columns}
        isHistoryPage={true}
        getBomDetails={props.getBomDetails}
        getDigiKeyBomEnrichment={props.getDigiKeyBomEnrichment}
      />
    </Layouts>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
  columns: state.column,
});
export default connect(mapStateToProps, {
  getBomHistory,
  getFile,
  getBomDetails,
  getDigiKeyBomEnrichment,
  getColumns,
})(History);
